import { ColorOptions, Icon, IconOptions } from '@jfs/ui-new'
import { defaultColors } from '@jfs/ui-new/src/theme/DefaultTheme'
import { useNavigation } from '@react-navigation/native'
import { Routes } from '../../nav/routes'
import { ModBox } from '../ModifiedBox/ModifiedBox'

export const SearchComp = () => {
  const navigation = useNavigation()
  return iconButton('SEARCH', navigation)
}

const iconButton = (id: string, navigation: any) => {
  return (
    <ModBox
      underlayColor="WHITE"
      onPress={() => navigation?.navigate(Routes.SEARCH)}
      testID="search-btn"
      bg={defaultColors.WHITE as ColorOptions}>
      <Icon id={id as IconOptions} color="BLUE" size={22} />
    </ModBox>
  )
}
